module.exports = __webpack_public_path__ + "static/media/googleAdmin.02eb9f4f.png";